exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ci-switcher{position:absolute;top:calc(50% - 76px);left:0;transform:translate(0, 50%);background-color:transparent;display:block;background-color:#fff;border:2px solid #002f60;color:#002f60;margin:5px;border-radius:50%;width:46px;height:46px;line-height:36px;font-size:24px;font-family:'arial';vertical-align:middle;cursor:pointer;box-shadow:0px 4px 5px -3px rgba(0,0,0,0.2),0px 8px 12px 1px rgba(0,0,0,0.14),0px 3px 15px 3px rgba(0,0,0,0.12)}\n", ""]);

// exports
